//@ts-expect-error
import Cookies from "js-cookie";
import axios, {AxiosInstance} from "axios";
import { COOKIE_NAME } from "./consts/user";

type ApiInstance = AxiosInstance & {
    setHeaders: (token?: string) => void;
};
const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL, 
}) as ApiInstance;

instance.setHeaders = (customToken?: string) => {
    const token = customToken ?? Cookies.get(COOKIE_NAME);
    instance.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}
export default instance;